import script from "./CheckoutIdentification.vue?vue&type=script&setup=true&lang=js"
export * from "./CheckoutIdentification.vue?vue&type=script&setup=true&lang=js"

import "./CheckoutIdentification.vue?vue&type=style&index=0&id=53c63522&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-53c63522"]])

export default __exports__